import React, { useContext, useEffect, useState } from 'react'

import { CircularProgress, Grid, Paper } from '@material-ui/core'
import Context from '../../../context'
import useStyles from './styles'

function DayAccess() {
  const classes = useStyles()

  const { validationsList, isLoading } = useContext(Context)
  const [fontSize, setFontSize] = useState(150)

  useEffect(() => {
    if (validationsList) {
      const { length } = `${validationsList.length}`

      switch (length) {
        case 2:
          setFontSize(100)
          break
        case 3:
          setFontSize(80)
          break
        case 4:
          setFontSize(60)
          break
        default:
          setFontSize(150)
          break
      }
    }
  }, [validationsList])

  return (
    <Paper elevation={0} className={classes.dayAccess}>
      {isLoading ? (
        <Grid className={classes.progressArea}>
          <CircularProgress />
        </Grid>
      ) : (
        <>
          <Grid container className={classes.dayAccessTitle}>
            <h4>VALIDAÇÕES</h4>
          </Grid>

          <Grid container style={{ fontSize }} className={classes.dayAccessNumber}>
            {validationsList && validationsList.length}
          </Grid>
        </>
      )}
    </Paper>
  )
}

export default DayAccess
